export const primengTranslations = {
  en: {
    // Calendar
    firstDayOfWeek: 0,
    dayNames:        ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
    dayNamesShort:   ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
    dayNamesMin:     ["Su","Mo","Tu","We","Th","Fr","Sa"],
    monthNames:      [
      "January","February","March","April","May","June",
      "July","August","September","October","November","December"
    ],
    monthNamesShort: [
      "Jan","Feb","Mar","Apr","May","Jun",
      "Jul","Aug","Sep","Oct","Nov","Dec"
    ],
    today:   "Today",
    clear:   "Clear",

    // Paginator
    first:     "First",
    last:      "Last",
    next:      "Next",
    previous:  "Previous",
    rowsPerPage: "Rows per page",

    // FilterMenu / FilterMatchMode
    startsWith:    "Starts with",
    contains:      "Contains",
    notContains:   "Not contains",
    endsWith:      "Ends with",
    equals:        "Equals",
    notEquals:     "Not equals",
    lt:            "Less than",
    lte:           "Less or equal",
    gt:            "Greater than",
    gte:           "Greater or equal",
    dateIs:        "Date is",
    dateIsNot:     "Date is not",
    dateBefore:    "Date before",
    dateAfter:     "Date after",
    clearFilter:   "Clear",
    apply:         "Apply",

    // ConfirmDialog
    accept: "Yes",
    reject: "No",

    // Other common labels
    emptyMessage:    "No records found",
    emptyFilterMessage: "No results found"
  },

  de: {
    // Calendar
    firstDayOfWeek: 1,
    dayNames:        ["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],
    dayNamesShort:   ["So","Mo","Di","Mi","Do","Fr","Sa"],
    dayNamesMin:     ["So","Mo","Di","Mi","Do","Fr","Sa"],
    monthNames:      [
      "Januar","Februar","März","April","Mai","Juni",
      "Juli","August","September","Oktober","November","Dezember"
    ],
    monthNamesShort: [
      "Jan","Feb","Mär","Apr","Mai","Jun",
      "Jul","Aug","Sep","Okt","Nov","Dez"
    ],
    today:   "Heute",
    clear:   "Löschen",

    // Paginator
    first:     "Erste",
    last:      "Letzte",
    next:      "Nächste",
    previous:  "Vorherige",
    rowsPerPage: "Einträge pro Seite",

    // FilterMenu / FilterMatchMode
    startsWith:    "Beginnt mit",
    contains:      "Enthält",
    notContains:   "Enthält nicht",
    endsWith:      "Endet mit",
    equals:        "Gleich",
    notEquals:     "Ungleich",
    lt:            "Kleiner als",
    lte:           "Kleiner gleich",
    gt:            "Größer als",
    gte:           "Größer gleich",
    dateIs:        "Datum ist",
    dateIsNot:     "Datum ist nicht",
    dateBefore:    "Datum davor",
    dateAfter:     "Datum danach",
    clearFilter:   "Zurücksetzen",
    apply:         "Anwenden",

    // ConfirmDialog
    accept: "Ja",
    reject: "Nein",

    // Other common labels
    emptyMessage:    "Keine Einträge gefunden",
    emptyFilterMessage: "Keine Ergebnisse"
  }
};
